import { Button, Icon } from "@validereinc/common-components";
import { copyTextToClipboard } from "@validereinc/utilities";
import classNames from "classnames/bind";
import React, { useEffect, useState } from "react";
import styles from "./ErrorDetailsCard.module.css";

const cx = classNames.bind(styles);

export const ErrorDetailsCard = ({
  title,
  content,
  onCopySuccess,
}: {
  title: string;
  content: string;
  onCopySuccess?: () => void;
}) => {
  const [isCopied, setIsCopied] = useState(false);

  useEffect(() => {
    if (isCopied) {
      setTimeout(() => setIsCopied(false), 2000);
    }
  }, [isCopied]);

  return (
    <div className={cx("container")}>
      <div className={cx("content-container")}>
        <p className={cx("title")}>{title}</p>
        <div className={cx("content")}>{content}</div>
      </div>
      <div className={cx("action")}>
        <Button
          variant="ghost"
          className={cx("copy-button")}
          onClick={() => {
            copyTextToClipboard(content)
              .then(() => setIsCopied(true))
              .then(() => onCopySuccess?.());
          }}
          slotLeft={
            <Icon
              variant={isCopied ? "check-circle" : "copy-simple"}
              size={24}
            />
          }
          title="Copy to clipboard"
        >
          {isCopied ? "Copied" : ""}
        </Button>
      </div>
    </div>
  );
};
